/**
 * 配置管理中文语言包
 */

export default {
  title: '基本配置',
  search: {
    configName: '配置名称',
    remarks: '备注',
    search: '搜索',
    reset: '重置',
    placeholder: {
      enterConfigName: '请输入配置名称',
      enterRemarks: '请输入备注'
    }
  },
  actions: {
    addConfig: '新增配置',
    batchDelete: '批量删除',
    totalRecords: '共 {count} 条记录'
  },
  table: {
    columns: {
      configName: '配置名称',
      configValue: '默认值',
      currentValue: '当前值',
      dataType: '数据类型',
      overrideable: '可覆盖',
      literals: '可选值',
      remarks: '备注',
      actions: '操作'
    },
    actions: {
      detail: '详情',
      edit: '编辑',
      setValue: '设置值',
      reset: '重置'
    }
  },
  modal: {
    title: {
      add: '新增配置定义',
      edit: '编辑配置定义',
      detail: '配置定义详情',
      value: '配置值详情',
      editValue: '编辑配置值'
    },
    form: {
      configName: '配置名称',
      configValue: '配置值',
      defaultValue: '默认值',
      currentValue: '当前值',
      dataType: '数据类型',
      overrideable: '可覆盖',
      literals: '可选值',
      remarks: '备注',
      placeholder: {
        enterConfigName: '请输入配置名称',
        enterConfigValue: '请输入配置值',
        enterDefaultValue: '请输入默认值',
        selectDataType: '请选择数据类型',
        enterLiterals: '请输入可选值列表',
        enterRemarks: '请输入备注'
      }
    },
    okText: '确定',
    cancelText: '取消'
  },
  message: {
    success: {
      create: '配置定义创建成功',
      update: '配置定义更新成功',
      updateValue: '配置值更新成功',
      createValue: '配置值创建成功',
      delete: '配置定义删除成功',
      batchDelete: '批量删除成功，共删除 {count} 条记录',
      reset: '配置值重置成功'
    },
    error: {
      createFailed: '配置定义创建失败',
      updateFailed: '配置定义更新失败',
      updateValueFailed: '配置值更新失败',
      createValueFailed: '配置值创建失败',
      deleteFailed: '配置定义删除失败',
      batchDeleteFailed: '批量删除失败',
      loadFailed: '数据加载失败',
      operationFailed: '操作失败',
      configNameExists: '配置名称已经存在',
      resetFailed: '配置值重置失败'
    },
    info: {
      noConfigDetailToReset: '没有配置详情记录需要重置'
    },
    warning: {
      noSelection: '请选择要删除的记录',
      noConfigId: '配置ID不存在'
    }
  },
  confirm: {
    delete: {
      title: '确认删除',
      content: '确定要删除配置定义 "{name}" 吗？',
      batchContent: '确定要删除选中的 {count} 条配置定义吗？',
      okText: '确定',
      cancelText: '取消'
    },
    reset: {
      title: '确认重置',
      content: '确定要重置配置 "{name}" 的值吗？这将重置当前租户的配置为默认值。',
      okText: '确定',
      cancelText: '取消'
    }
  },
  dataType: {
    string: '字符串',
    number: '数值',
    boolean: '布尔值'
  },
  tag: {
    yes: '是',
    no: '否'
  }
}
